module.exports = __webpack_public_path__ + "assets/images/user4-128x128.jpg?071aa8e712b7fc70b411d80b4715128c";


//////////////////
// WEBPACK FOOTER
// ./_source/images/user4-128x128.jpg
// module id = 402
// module chunks = 0